import { Content } from '../models/content';

export const polishContent: Content = {
  translation: {
    title:
      'Europejski operator pooli stakingowej Cardano<br /> zaprojektowany i zbudowany przez <a href="mailto:adapool_charles@pm.me">@Karola</a> i <a href="mailto:adapool_mikael@pm.me">@Michała</a>.',
    whoAreWe: 'Kim jesteśmy?',
    whyJoinUs: 'Dlaczego warto do nas dołączyć?',
    poolDetails: 'Szczegóły dotyczące puli',
    s1: {
      p1: 'Nazywamy się Karol 😊 i Michał 😉, jesteśmy partnerami zmotywowanymi do demokratyzacji korzystania z krypto-waluty.',      
      p2:'Mika, która pomaga w administracji i jej cyfrowej transformacji, wnosi swoje techniczne i humanistyczne doświadczenie. Charles wnosi do projektu swoje ponad dziesięcioletnie doświadczenie w dziedzinie programowania. Razem entuzjastycznie uczestniczymy w rozwoju sieci Cardano!',
      p3:'Jesteśmy zaangażowani w kryptowalutę od 2017 roku, mieliśmy szczęście, że udało nam się osiągnąć zysk na szczycie rynku. Wtedy właśnie odkryliśmy projekt Cardano i od tamtej pory śledzimy go z wielkim zainteresowaniem.',
      p4: 'Naszym celem z ADA Pool Europe jest stworzenie społeczności podobnie myślących ludzi, którzy wierzą w Cardano i którym oferujemy dobre doświadczenie w łączeniu kapitału.',
    },
    s2: {
      p1: 'Jesteśmy zmotywowani, aby zdemokratyzować korzystanie z kryptowaluty.',
      p2: ' infrastruktura wysokiej dostępności',
      p3: ' z ograniczonymi opłatami',
      p4: ' otwarte dla jak największej liczby osób',
      p5: ' dedykowane i bezpieczne serwery',
p6:'Nasza europejska pula stakingowa Cardano ma na celu wzmocnienie i decentralizację sieci Cardano. Oferujemy wysokiej dostępności, niezawodne i bezpieczne stakowanie oparte na dwóch węzłach przekaźnikowych i jednym węźle producenckim w profesjonalnych centrach serwerowych. Naszym celem jest stworzenie dobrego doświadczenia uczestnictwa.',
      p7: "Kładziemy duży nacisk na wydajność i bezpieczeństwo infrastrukyury naszej puli. Chcemy również umożliwić jak największej liczbie z Was udział w przygodzie z kryptowalutą.",
      p8: 'Przechowując swoje ADA w naszej puli uczestniczysz w sieci Cardano.',
      p9: "✔&nbsp;Twoje ADA nigdy nie są zablokowane, możesz je przenieść w każdej chwili i bez opł at. &nbsp;;<br><br> ✔&nbsp;Twoje ADA nigdy Cię nie opuszczą, nie możesz ich stracić przez staking.&nbsp;;<br><br> ✔&nbsp;Twoje nagrody są automatycznie reinwestowane, co 5 dni otrzymujesz swoją część wygranej, która jest automatycznie stakowana &nbsp;;<br><br> ✔&nbsp;Możesz zacząć stakować swoje ADA, nawet jeśli masz ich bardzo mało.",
    },
    s3: {
      p1: 'Aby uczestniczyć w sieci Cardano, nie ma nic łatwiejszego!<br> Wystarczy, że będą Państwo przechowywać waszą kryąptowalutę ADA w naszej puli "adapool-europe".',
      p2: 'Zaloguj się, aby oddelegować swojego ADA&nbsp;:',
      p3: 'Interactive widget',
      p4: 'Pledge',
      p5: 'Właściciele&nbsp;:',
      p6: 'Wartość&nbsp;:',
      p7: ' Stake',
      p8: 'Delegatów :',
      p9: 'Wartość&nbsp;:',
      p10:'Koszty',
      p11:'Koszty zmienne&nbsp;:',
      p12:'Koszty stałe&nbsp;:',
      p13:'Kursy kryptowalut'
    },
    footer:{
      p1:'Skontaktuj się z nami'
    }
  },
};
